import search from "./search/search";

export default {
    search
};
